module.exports = __webpack_public_path__ + "static/media/bio_age_saf_dat.48b2d69d.png";